/**
 * 제공된 string이 중국어로 시작하는지 여부를 반환한다.
 * @param {string} str
 * @returns {boolean} 검사 결과
 */
export const isStartWithZh = (str: string): boolean => {
  return /^[\u4e00-\u9fa5]/.test(str);
};
